import getCookieMap from './getCookieMap';
import {BASKET_IDENTITY} from '../modules/basket/model';
import {KNOWN_COOKIES} from '../constants';

export default function harvestIdentifiers() {
  const cookies = getCookieMap(document.cookie);
  const matchedCookies = KNOWN_COOKIES.reduce((map, key) => {
    return cookies[key]
      ? {...map, [key]: cookies[key] }
      : map
  }, {});

  const basketId = localStorage.getItem(BASKET_IDENTITY);

  if (!basketId)
    return matchedCookies;

  return {
    ...matchedCookies,
    basketId: JSON.parse(basketId),
  };
}